/**
 * A duration in milliseconds as the shortest readable "1 h 12 min", "38 min",
 * "45 s", "2 d 3 h" (spec 2026-10-27-11 §5). Seconds are dropped from an hour
 * up, minutes from a day up: nobody quotes an ingestion time to the second.
 */
export function formatDuration(ms: number | null | undefined, lang: string = 'en'): string {
    if (ms === null || ms === undefined || Number.isNaN(ms)) return '—'
    const total = Math.max(0, Math.round(ms / 1000))
    const day = lang.startsWith('fr') ? 'j' : 'd'
    const days = Math.floor(total / 86400)
    const hours = Math.floor((total % 86400) / 3600)
    const minutes = Math.floor((total % 3600) / 60)
    const seconds = total % 60
    if (days > 0) return hours > 0 ? `${days} ${day} ${hours} h` : `${days} ${day}`
    if (hours > 0) return minutes > 0 ? `${hours} h ${minutes} min` : `${hours} h`
    if (minutes > 0) return `${minutes} min`
    return `${seconds} s`
}
